import {AppRegistry} from 'react-native';
import {name as appName} from './app.json';
import './src/global/fonts.css';

import feather from 'react-native-vector-icons/Fonts/Feather.ttf';
import ionicons from 'react-native-vector-icons/Fonts/Ionicons.ttf';
import fontAwesome from 'react-native-vector-icons/Fonts/FontAwesome.ttf';
import fontAwesome5Solid from 'react-native-vector-icons/Fonts/FontAwesome5_Solid.ttf';
import fontAwesome5Regular from 'react-native-vector-icons/Fonts/FontAwesome5_Regular.ttf';
import fontAwesome5Brands from 'react-native-vector-icons/Fonts/FontAwesome5_Brands.ttf';

import fontAwesome6Solid from 'react-native-vector-icons/Fonts/FontAwesome6_Solid.ttf';
import fontAwesome6Regular from 'react-native-vector-icons/Fonts/FontAwesome6_Regular.ttf';
import fontAwesome6Brands from 'react-native-vector-icons/Fonts/FontAwesome6_Brands.ttf';

import materialIcons from 'react-native-vector-icons/Fonts/MaterialIcons.ttf';
import materialCommunityIcons from 'react-native-vector-icons/Fonts/MaterialCommunityIcons.ttf';

import temaUrbis from './src/global/styles/urbis/new_theme';
import temaPicpay from './src/global/styles/picpay/new_theme';
import temaWebmotors from './src/global/styles/webmotors/new_theme';
import temaDefault from './src/global/styles/legacy/new_theme_dark';
import temaBarataoWeb from './src/global/styles/legacy/new_theme';

import AppWeb from './App.web';
import {api} from './src/services/api';

// ======== FONTS =========
const iconFontStyles = `
  @font-face {
    src: url(${fontAwesome});
    font-family: "FontAwesome";
  }
 @font-face {
    src: url(${fontAwesome5Solid});
    font-family: "FontAwesome5_Solid";
  }
  @font-face {
    src: url(${fontAwesome5Regular});
    font-family: "FontAwesome5_Regular";
  }
  @font-face {
    src: url(${fontAwesome5Brands});
    font-family: "FontAwesome5_Brands";
  }

  @font-face {
    src: url(${fontAwesome6Solid});
    font-family: "FontAwesome6_Solid";
  }
  @font-face {
    src: url(${fontAwesome6Regular});
    font-family: "FontAwesome6_Regular";
  }
  @font-face {
    src: url(${fontAwesome6Brands});
    font-family: "FontAwesome6_Brands";
  }
  @font-face {
    src: url(${ionicons});
    font-family: "Ionicons";
  }
  @font-face {
    src: url(${feather});
    font-family: "Feather";
  }
     @font-face {
    src: url(${materialIcons});
    font-family: "MaterialIcons";
  }
       @font-face {
    src: url(${materialCommunityIcons});
    font-family: "MaterialCommunityIcons";
  }
`;

const style = document.createElement('style');
style.type = 'text/css';
if (style.styleSheet) {
  style.styleSheet.cssText = iconFontStyles;
} else {
  style.appendChild(document.createTextNode(iconFontStyles));
}
document.head.appendChild(style);

function init() {
  const rootElement = document.getElementById('root');
  if (!rootElement) {
    console.error('Elemento root não encontrado!');
    return;
  }

  const query = new URLSearchParams(window.location.search);

  const clientId = query.get('clientId');
  const token = query.get('token');
  const lat = query.get('lat');
  const lng = query.get('lng');
  const debitoVeicular = query.get('debitoVeicular') === 'true';

  async function fetchUserData(token, incentiveUserId = null) {
    try {
      api.defaults.headers.common.Authorization = `${token}`;

      AppRegistry.registerComponent(appName, () => AppWeb);
      AppRegistry.runApplication(appName, {
        rootTag: rootElement,
        initialProps: {
          clientId,
          incentiveUserId,
          token,
          lat,
          lng,
          debitoVeicular,
          theme: clientId === 'urbis' ? temaUrbis : temaDefault,
        },
      });
    } catch (error) {
      console.warn('Erro ao buscar dados do usuário:', error);
    }
  }

  async function validateToken(token) {
    try {
      showLoading('Estamos validando seu acesso...');

      const response = await api.post('/external/session/exchange', {
        id_token: token,
      });

      showLoading('Aguarde mais um momento...');

      const {token: authToken, incentiveUserId} = response.data;
      fetchUserData(authToken, incentiveUserId);
    } catch (error) {
      console.warn('Acesso negado!');
      rootElement.innerHTML = `
      <div style="display:flex;align-items:center;justify-content:center;height:100vh;font-family:sans-serif;color:#E83F5B;">
        <h2>Acesso negado</h2>
      </div>
    `;
      return false;
    }
  }

  function showLoading(message) {
    rootElement.innerHTML = `
    <div style="display:flex;flex-direction:column;align-items:center;justify-content:center;height:100vh;font-family:sans-serif;color:#333;">
      <div style="width:40px;height:40px;border:4px solid #ccc;border-top-color:#222;border-radius:50%;animation:spin 1s linear infinite;"></div>
      <h3 style="margin-top:20px;">${message}</h3>
      <style>
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      </style>
    </div>
  `;
  }

  if (
    !clientId ||
    (clientId !== 'urbis' &&
      clientId !== 'picpay' &&
      clientId !== 'webmotors' &&
      clientId !== 'barataoweb')
  ) {
    console.warn('Acesso negado!');
    rootElement.innerHTML = `
        <div style="display:flex;align-items:center;justify-content:center;height:100vh;font-family:sans-serif;color:#E83F5B;">
          <h2>Acesso negado</h2>
        </div>
      `;
    return;
  }

  if (clientId === 'urbis') {
    return validateToken(token);
  }

  AppRegistry.registerComponent(appName, () => AppWeb);
  AppRegistry.runApplication(appName, {
    rootTag: rootElement,
    initialProps: {
      clientId,
      incentiveUserId: null,
      token: null,
      lat,
      lng,
      debitoVeicular,
      theme:
        clientId === 'picpay'
          ? temaPicpay
          : clientId === 'barataoweb'
          ? temaBarataoWeb
          : clientId === 'webmotors'
          ? temaWebmotors
          : temaDefault,
    },
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
